export const TABLE_DATA = {
  heading: "Supported Migration Scenarios",
  tableHeading: ["Source", "Destination", "Migration Type"],
  tableData: [
    {
      Source: (
        <>
          VMware
          <br />
          vSphere
        </>
      ),
      Destination: (
        <>
          MOST
          <br />
          (OpenStack)
        </>
      ),
      Migration_type: "Full stack (VMs, storage, network)",
    },
    {
      Source: " Nutanix AHV",
      Destination: (
        <>
          MOST
          <br />
          (OpenStack)
        </>
      ),
      Migration_type: "Workload + Storage Replication",
    },
    {
      Source: " VMware",
      Destination: "Hosted VMware",
      Migration_type: "Datacenter relocation to OneMind",
    },
    {
      Source: " VMware",
      Destination: "Hybrid Cloud",
      Migration_type: "MOST + Public Cloud + OpenShift support",
    },
  ],
};
